import React from 'react'

type Props = {
  className?: string,
}

const GDPRSwedish = (props: Props) => {
  return (
    <div className={props.className}>
      <p>Statusfälgar i Sverige AB (559329-8051) behandlar personuppgifter i enlighet med Dataskyddsförordningen (GDPR). Du samtycker till detta när du besöker vår webbsida och beställer. Här förklarar vi vad vi gör med dina uppgifter:</p>
      <ul>
        <li>Vi använder informationen endast för det ändamål som krävs.</li>
        <li>Vi samlar inte in och lagrar inte information som inte är nödvändig för det ändamål som angetts.</li>
        <li>Vi kommunicerar tydligt hur personuppgifter samlas in, lagras och används och ser till att berörda personers rättigheter tillgodoses.</li>
        <li>Vi tillser att behandling av personuppgifter är spårbar och att vi eller våra personuppgiftsbiträden ansvarar för behandlingen.</li>
        <li>Vi tillser att personuppgifter är tillgängliga på det sätt vi har angett.</li>
        <li>Vi tillser att personuppgifter inte till följd av vårdslöshet eller uppsåt raderas eller förändras.</li>
      </ul>
      <p>
        Om du har frågor eller om du motsätter dig hur vi behandlar dina personuppgifter är du välkommen att kontakta oss på info@statusfalgar.se
        Vilka personuppgifter samlar Statusfälgar i Sverige AB in?
      </p>
      <ul>
        <li>Personnummer</li>
        <li>Telefon</li>
        <li>IP nummer</li>
        <li>Epost</li>
        <li>Namn & Efternamn</li>
        <li>Adress</li>
        <li>Registreringsnummer</li>
      </ul>

      <h3>Varför samlar ni in dessa uppgifter och i vilket syfte?</h3>
      <p>
        Vi samlar in dina personuppgifter för att kunna leverera din beställning. Endast nödvändiga uppgifter samlas in för att kunna leverera varorna till dig. Vi samlar även in uppgifter för garanti ärenden som rör din beställning. Förklaras nedan:
      </p>
      <ul>
        <li>Personnummer samlar vi in för att kunna erbjuda dig som kund säkra och personliga betalningsalternativ så som faktura, kort och delbetalning.  Vi tar även ditt personnummer för framtida garanti ärenden. Du samtycker till detta när du handlar hos oss.</li>
        <li>Telefonnummer samlar vi in för att kunna kontakta dig vid ärenden som rör din beställning samt avvisera din försändelse.</li>
        <li>IP nummer samlar vi in för att skydda dig och oss själva mot internet bedrägerier.</li>
        <li>Email samlar vi in för att ha möjligheten att e-posta dig en orderbekräftelse samt kontakta dig vid ärenden som rör din beställning.</li>
        <li>Namn och efternamn samlar vi in för att kunna skicka varorna och skapa ett personligt kvitto. Vid val av upphämtning samlar vi in detta för att du ska kunna identifiera dig vid kontakt med Statusfälgar i Sverige.</li>
        <li>Adress samlar vi in för att kunna leverera dina beställda varor. Väljer du att hämta dina produkter hos oss samlar vi fortfarande in din adress för att vid behov skicka kompletterande varor/delar.</li>
        <li>Bilens registreringsnummer samlar vi in för att säkerställa passform som rör din beställning. Exempelvis att fälgar, däck & tillbehör passar bilen.</li>
      </ul>
      <p>
        Viktigt att veta: Det är du själv som godkänner om vi får ta del av dina personuppgifter. Vi kan dessvärre inte processa ditt ärende om du inte godkänner villkoren.  Du godkänner villkoren i samband med köp på Statusfälgar i Sverige. Har du godkänt villkoren och vill dra tillbaka godkännandet så kan du mejla dataskyddsansvarig info@statusfalgar.se och be om att få dig raderad ur våra system.
      </p>
      <h2>FAQ</h2>
      <strong>Hur länge lagrar ni mina uppgifter?</strong>
      <p>
        Vi spar dina uppgifter så länge det är relevant för att hantera din orderhistorik eller tills du ber oss att radera dom. Vi spar dina uppgifter för att kunna hjälpa dig vid framtida problem som rör din beställning.
        <br />
        Vill du få uppgifterna raderade kontaktar du oss på info @ statusfalgar.se eller 0852705264
      </p>
      <strong>Vart lagrar ni mina uppgifter?</strong>
      <p>
        Vi lagrar dina uppgifter i en säker och krypterad databas där endast vi på Statusfälgar i Sverige kan ta del av dina personuppgifter. När du beställer online lagras dina uppgifter hos Svea Ekonomi, Walley och Statusfälgar i Sverige. Du kan när som helst be om att få dina uppgifter raderade genom att kontakta info@statusfalgar.se
      </p>
      <strong>Jag vill att ni tar bort mina uppgifter hur gör jag?</strong>
      <p>
        Du kontaktar dataskyddsansvarig på Statusfälgar i Sverige och be om att få dina uppgifter raderade. Kontakt sker per mail: info@statusfalgar.se
      </p>
      <strong>Jag vill ändra den informationen ni har om mig, hur gör jag?</strong>
      <p>
        Du kontaktar dataskyddsansvarig info@statusfalgar.se och ber om att få dina uppgifter ändrade enligt önskemål.
      </p>
      <strong>Jag vill ta del av den informationen ni har registrerat om mig</strong>
      <p>Du kontaktar info@statusfalgar.se eller 0852705264  och ber om att få det.</p>

      <strong>Jag har skrivit in mig på ert nyhetsbrev men vill inte vara kvar, hur gör jag?</strong>
      <p>Det är enkelt! Maila info@statusfalgar.se så tar vi genast bort dig inom 72timmar.</p>

      <strong>Vilka får ta del av mina uppgifter?</strong>
      <p>Statusfälgar i Sverige AB, Nshift, berörd fraktfirma, Svea ekonomi, samt Walley</p>

      <p>
        Vi använder SSL som skyddar trafiken mellan dig och oss.
        Som skydd på webben används SSL-protokoll (Secure Sockets Layer). SSL möjliggör stark kryptering av förbindelsen mellan användarens webbläsarprogram och webbservern. Krypteringen skyddar datatrafiken på så sätt att utomstående inte kan komma åt konfidentiella uppgifter genom att följa upp förbindelsen.
      </p>
    </div>
  )
}

export default GDPRSwedish